import React from 'react';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

const SearchInput = ({ label, placeholder = "Search...", value, onChange, className = "" }) => {
  return (
    <div className={`product-setup-search pcu-flex-grow-1 ${className}`}>
      {label && <div className="pcu-font-11 pcu-font-700 pcu-margin-bottom-6 pcu-color-title pcu-opacity-50 pcu-letter-spacing-1 pcu-uppercase" style={{ fontFamily: 'var(--font-family-primary)' }}>{label}</div>}
      <Input
        placeholder={placeholder}
        prefix={<SearchOutlined className="pcu-color-primary" />}
        size="middle"
        className="pcu-radius-8"
        style={{ height: '34px' }}
        value={value}
        onChange={onChange}
        allowClear
      />
    </div>
  );
};

export default SearchInput;
